"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRoutes = exports.asyncRoutes = void 0;
exports.resetRouter = resetRouter;
var _interopRequireWildcard2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
_vue.default.use(_vueRouter.default);

/* Layout */

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
var constantRoutes = exports.constantRoutes = [{
  path: '/login',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/login/index'));
    });
  },
  hidden: true
}, {
  path: '/',
  redirect: '/login',
  children: [{
    path: '/login',
    name: 'login',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/login/index'));
      });
    }
  }]
}, {
  path: '/404',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/404'));
    });
  },
  hidden: true
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
var asyncRoutes = exports.asyncRoutes = [{
  path: '/DefaultEntryPage',
  component: _layout.default,
  redirect: '/superTubePage',
  name: 'DefaultEntryPage',
  meta: {
    title: '超管默认页'
  },
  hidden: true,
  children: [{
    path: '/superTubePage',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/DefaultEntryPage/superTubePage/index'));
      });
    },
    name: 'superTubePage',
    meta: {
      title: '超管默认页'
    },
    hidden: true
  }]
}, {
  path: '/systemAdministrator/creatApp',
  component: _layout.default,
  redirect: '/systemAdministrator/creatApp/index',
  name: 'systemAdministrator',
  meta: {
    title: 'APP创建',
    roles: ['sys_admin']
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/systemAdministrator/creatApp/index'));
      });
    },
    // Parent router-view
    name: 'creatApp',
    meta: {
      title: 'APP创建',
      roles: ['sys_admin']
    }
  }, {
    path: 'appContent',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/systemAdministrator/creatApp/appContent'));
      });
    },
    name: 'appContent',
    meta: {
      title: '基础管理',
      roles: ['app_admin']
    }
  }, {
    path: '/systemAdministrator/creatApp/appDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/systemAdministrator/creatApp/appDetail'));
      });
    },
    // Parent router-view
    name: 'appDetail',
    meta: {
      title: 'app配置',
      isMore: true
    },
    hidden: true
  }, {
    path: 'appInformation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/systemAdministrator/creatApp/appInformation'));
      });
    },
    // Parent router-view
    name: 'appInformation',
    meta: {
      title: 'APP信息'
    },
    hidden: true
  }]
}, {
  path: '/authorityManagement',
  component: _layout.default,
  redirect: '/personnelManagement',
  name: 'personnelManagement',
  meta: {
    title: '账户权限',
    roles: ['app_admin']
  },
  children: [{
    path: 'personnelManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement/personnelManagement'));
      });
    },
    name: 'personnelManagement',
    meta: {
      title: '人员管理',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'logList',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement_user_app/logList'));
      });
    },
    name: 'logList',
    meta: {
      title: '管理日志',
      roles: ['app_admin'],
      keepAlive: false
    }
  }, {
    path: 'roleAuthority',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement/roleAuthority'));
      });
    },
    name: 'roleAuthority',
    meta: {
      title: '角色权限',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'personnelAuthorityManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement/personnelAuthorityManagement'));
      });
    },
    name: 'personnelAuthorityManagement',
    meta: {
      title: 'APP人员管理',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'navigationMenu',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement/navigationMenu'));
      });
    },
    name: 'navigationMenu',
    meta: {
      title: '导航菜单管理',
      roles: ['app_admin'],
      keepAlive: true
    }
  }]
}, {
  path: '/riskControl',
  component: _layout.default,
  redirect: '/riskControl/index',
  name: 'riskControl',
  meta: {
    title: '风险控制(超管)',
    roles: ['sys_admin']
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/riskControl/index'));
      });
    },
    name: 'riskControl_index',
    meta: {
      title: '风险控制',
      roles: ['sys_admin']
    },
    hidden: true
  }]
}, {
  path: '/riskControlLittleB',
  component: _layout.default,
  redirect: '/riskControlLittleB/index',
  name: 'riskControlLittleB',
  meta: {
    title: '风险控制(小b端)',
    roles: ['sys_admin']
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/riskControlLittleB/index'));
      });
    },
    name: 'riskControlLittleB_index',
    meta: {
      title: '小b端风险控制'
    },
    hidden: true
  }]
}, {
  path: '/ListingsExhibitionHall',
  component: _layout.default,
  redirect: '/ListingsExhibitionHall/index',
  name: 'ListingsExhibitionHall',
  meta: {
    title: '榜单会场活动管理(超管)',
    roles: ['sys_admin']
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/ListingsExhibitionHall/index'));
      });
    },
    name: 'ListingsExhibitionHall_index',
    meta: {
      title: '榜单会场活动管理',
      roles: ['sys_admin']
    },
    hidden: true
  }]
}, {
  path: '/systemAdministrator/activityCreation',
  component: _layout.default,
  redirect: '/systemAdministrator/activityCreation/index',
  name: 'activityCreation',
  meta: {
    title: '活动管理',
    roles: ['sys_admin', 'activity_admin']
  },
  children: [{
    path: 'activityCreation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/systemAdministrator/activityCreation/index'));
      });
    },
    name: 'activityCreation',
    meta: {
      title: '通用官方活动',
      roles: ['sys_admin', 'activity_admin']
    }
  }, {
    path: 'universalH5Page',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/systemAdministrator/universalH5Page/index'));
      });
    },
    name: 'universalH5Page',
    meta: {
      title: '通用H5页面',
      roles: ['sys_admin', 'activity_admin']
    }
  }, {
    path: 'otherH5Page',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/systemAdministrator/otherH5Page/index'));
      });
    },
    name: 'otherH5Page',
    meta: {
      title: '第三方代下单',
      roles: ['sys_admin', 'activity_admin']
    }
  }]
},
// {
//   path: '/systemAdministrator/personnelManage',
//   component: Layout,
//   redirect: '/systemAdministrator/personnelManage/index',
//   name: 'personnelManage',
//   meta: {
//     title: '用户管理',
//     roles: ['sys_admin']
//   },
//   children: [
//     {
//       path: 'personnelManage',
//       component: () => import('@/views/systemAdministrator/personnelManage/index'),
//       name: 'personnelManage',
//       meta: { title: '用户管理', roles: ['sys_admin'] }
//     }
//   ]
// },
// {
//   path: '/systemAdministrator/activityCreation',
//   component: Layout,
//   redirect: '/systemAdministrator/activityCreation/index',
//   name: 'activityCreation',
//   meta: {
//     title: '通用官方活动',
//     roles: ['sys_admin', 'activity_admin']
//   },
//   children: [
//     {
//       path: 'activityCreation',
//       component: () => import('@/views/systemAdministrator/activityCreation/index'),
//       name: 'activityCreation',
//       meta: { title: '通用官方活动', roles: ['sys_admin', 'activity_admin'] }
//     }
//   ]
// },
// {
//   path: '/systemAdministrator/universalH5Page',
//   component: Layout,
//   redirect: '/systemAdministrator/universalH5Page/index',
//   name: 'universalH5Page',
//   meta: {
//     title: '通用H5页面',
//     roles: ['sys_admin', 'activity_admin']
//   },
//   children: [
//     {
//       path: 'universalH5Page',
//       component: () => import('@/views/systemAdministrator/universalH5Page/index'),
//       name: 'universalH5Page',
//       meta: { title: '通用H5页面', roles: ['sys_admin', 'activity_admin'] }
//     }
//   ]
// },
// {
//   path: '/systemAdministrator/otherH5Page',
//   component: Layout,
//   redirect: '/systemAdministrator/otherH5Page/index',
//   name: 'otherH5Page',
//   meta: {
//     title: '第三方代下单',
//     roles: ['sys_admin', 'activity_admin']
//   },
//   children: [
//     {
//       path: 'otherH5Page',
//       component: () => import('@/views/systemAdministrator/otherH5Page/index'),
//       name: 'otherH5Page',
//       meta: { title: '第三方代下单', roles: ['sys_admin', 'activity_admin'] }
//     }
//   ]
// },

// 小b端 ----------------------------------------------
{
  path: '/dataMarket',
  component: _layout.default,
  redirect: '/dataMarket/index',
  name: 'dataMarket_large',
  meta: {
    title: '数据大盘',
    roles: ['app_admin']
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/dataMarket/index'));
      });
    },
    name: 'dataMarket',
    meta: {
      title: '数据大盘',
      roles: ['app_admin'],
      keepAlive: false
    },
    hidden: true
  }]
}, {
  path: '/member',
  component: _layout.default,
  redirect: '/member/membershipList/index',
  name: 'membershipList1',
  meta: {
    title: '会员管理',
    roles: ['app_admin']
  },
  children: [{
    path: 'membershipList',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/member/membershipList/index'));
      });
    },
    name: 'membershipList',
    meta: {
      title: '会员列表',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'userDetails',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/member/userDetails/index'));
      });
    },
    name: 'userDetails',
    meta: {
      title: '会员详情',
      roles: ['app_admin'],
      isMore: true
    },
    hidden: true
  }, {
    path: 'feedback',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/member/feedback/index'));
      });
    },
    name: 'feedback',
    meta: {
      title: '反馈意见',
      keepAlive: true,
      roles: ['app_admin']
    }
  }, {
    path: 'labelManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/member/labelManagement/index'));
      });
    },
    name: 'labelManagement',
    meta: {
      title: '标签管理',
      keepAlive: true
    }
  }]
}, {
  path: '/orderManagement',
  component: _layout.default,
  redirect: '/orderManagement/commissionBaseDeductionSetting/index',
  name: 'withdrawalManagement',
  meta: {
    title: '订单管理',
    roles: ['app_admin']
  },
  children: [{
    path: 'commissionBaseDeductionSetting',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/orderManagement/commissionBaseDeductionSetting/index'));
      });
    },
    name: 'commissionBaseDeductionSetting',
    meta: {
      title: '订单管理',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'orderDetails',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/orderManagement/commissionBaseDeductionSetting/orderDetails'));
      });
    },
    name: 'orderDetails',
    meta: {
      title: '订单详情',
      roles: ['app_admin']
    },
    hidden: true
  }
  // {
  //   path: 'telephoneTransaction',
  //   component: () => import('@/views/orderManagement/telephoneTransaction/index'),
  //   name: 'telephoneTransaction',
  //   meta: { title: '话费交易订单', roles: ['app_admin'] }
  // },
  // {
  //   path: 'promotionOrder',
  //   component: () => import('@/views/orderManagement/promotionOrder/index'),
  //   name: 'promotionOrder',
  //   meta: { title: '佣金基数扣除', roles: ['app_admin'] }
  // }
  ]
}, {
  path: '/appNewRenovation',
  component: _layout.default,
  name: 'newRenovation',
  meta: {
    title: '装修',
    roles: []
  },
  children: [{
    path: 'home/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/appNewRenovation/home/index'));
      });
    },
    name: 'appNewRenovation_hone',
    meta: {
      title: '首页装修',
      roles: [],
      keepAlive: true
    }
  }, {
    path: 'home/renovation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/appNewRenovation/home/home_renovation'));
      });
    },
    name: 'home_renovation',
    meta: {
      title: '',
      roles: []
    },
    hidden: true
  }, {
    path: 'userCenter/renovation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/appNewRenovation/userCenter/userCenter_renovation'));
      });
    },
    name: 'userCenter_renovation',
    meta: {
      title: '',
      roles: []
    },
    hidden: true
  }, {
    path: 'userCenter/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/appNewRenovation/userCenter/index'));
      });
    },
    name: 'appNewRenovation_userCenter',
    meta: {
      title: '个人中心装修',
      roles: []
    }
  }]
}, {
  path: '/operationManagement',
  component: _layout.default,
  redirect: '/operationManagement/marketingPosition/index',
  name: 'marketingPosition1',
  meta: {
    title: '运营管理',
    roles: ['app_admin']
  },
  children: [{
    path: 'appRenovation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/appRenovation/index'));
      });
    },
    name: 'appRenovation',
    meta: {
      title: 'APP装修',
      roles: ['app_admin']
    }
  }, {
    path: 'scrunchieArrangement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/scrunchieArrangement/index'));
      });
    },
    name: 'scrunchieArrangement',
    meta: {
      title: '发圈管理',
      roles: ['app_admin']
    }
  }, {
    path: 'BusinessSchool',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/BusinessSchool/index'));
      });
    },
    name: 'BusinessSchool',
    meta: {
      title: '商学院配置',
      keepAlive: true,
      roles: ['app_admin']
    }
  }, {
    path: 'posterManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/posterManagement/index'));
      });
    },
    name: 'posterManagement',
    meta: {
      title: '海报管理',
      keepAlive: true,
      roles: ['app_admin']
    }
  }, {
    path: 'personalCenter',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/personalCenter/index'));
      });
    },
    name: 'personalCenter',
    meta: {
      title: '个人中心管理',
      roles: ['app_admin']
    }
  }, {
    path: 'popupManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/popupManagement/index'));
      });
    },
    name: 'popupManagement',
    meta: {
      title: '弹窗管理',
      roles: ['app_admin']
    }
  }, {
    path: 'secondaryMarketingPosition',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/secondaryMarketingPosition/index'));
      });
    },
    name: 'secondaryMarketingPosition',
    meta: {
      title: '二级营销位管理',
      roles: ['app_admin']
    }
  }, {
    path: 'BeginnerCourse',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/BeginnerCourse/index'));
      });
    },
    name: 'BeginnerCourse',
    meta: {
      title: '新手教程'
    }
  }, {
    path: 'customizePageManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/customizePageManagement/index'));
      });
    },
    name: 'customizePageManagement',
    meta: {
      title: '自定义页面管理',
      roles: ['app_admin']
    }
  }, {
    path: 'customPage',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/customPage/index'));
      });
    },
    name: 'customPage',
    meta: {
      title: 'new自定义页面'
    }
  }, {
    path: 'renovation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/customPage/renovation'));
      });
    },
    name: 'renovation',
    meta: {
      title: '自定义页面装修'
    },
    hidden: true
  }, {
    path: 'customerServiceInformation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/customerServiceInformation/index'));
      });
    },
    name: 'customerServiceInformation',
    meta: {
      title: '客服信息配置'
    }
  }]
}, {
  path: '/activityManagement',
  component: _layout.default,
  redirect: '/operationManagement/marketingPosition/index',
  name: 'activityManagement',
  meta: {
    title: '活动管理',
    roles: ['app_admin']
  },
  children: [{
    path: 'customizePageManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/customizePageManagement/index'));
      });
    },
    name: 'customizePageManagement',
    meta: {
      title: '自定义页面管理',
      roles: ['app_admin']
    }
  }, {
    path: 'goodsListActive',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/goodsListActive/index'));
      });
    },
    name: 'goodsListActive',
    meta: {
      title: '商品列表活动',
      roles: ['app_admin']
    }
  }, {
    path: 'aggregatePageManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/aggregatePageManagement/index'));
      });
    },
    name: 'aggregatePageManagement',
    meta: {
      title: '聚合页管理',
      roles: ['app_admin']
    }
  }, {
    path: 'LittleActivityCreation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/LittleActivityCreation/index'));
      });
    },
    name: 'LittleActivityCreation',
    meta: {
      title: '自定义活动管理',
      roles: ['app_admin'],
      keepAlive: true
    }
  }]
}, {
  path: '/marketingFunction',
  component: _layout.default,
  redirect: '/operationManagement/marketingPosition/index',
  name: 'marketingFunction',
  meta: {
    title: '营销活动管理'
  },
  children: [{
    path: 'activitySetting',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/supersubsidy/index'));
      });
    },
    redirect: '/supersubsidy/basicSetup/index',
    name: 'activitySettings',
    meta: {
      title: '礼金补贴活动'
    },
    children: [{
      path: 'index',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/activitySetting/index'));
        });
      },
      name: 'activitySetting',
      meta: {
        title: '活动设置'
      }
    }, {
      path: 'subsidyDetail',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/operationManagement/activitySetting/subsidyDetail'));
        });
      },
      name: 'subsidyDetail',
      meta: {
        title: '补贴明细'
      }
    }]
  }, {
    path: 'supersubsidy',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/supersubsidy/index'));
      });
    },
    redirect: '/supersubsidy/basicSetup/index',
    name: 'supersubsidy',
    meta: {
      title: '礼金补贴活动'
    },
    children: [{
      path: 'marketingEvents',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/supersubsidy/marketingEvents/index'));
        });
      },
      name: 'marketingEvents',
      meta: {
        title: '活动管理'
      }
    }, {
      path: 'marketingCommodity',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/supersubsidy/marketingCommodity/index'));
        });
      },
      name: 'marketingCommodity',
      meta: {
        title: '商品管理'
      }
    }, {
      path: 'marketingOrder',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/supersubsidy/marketingOrder/index'));
        });
      },
      name: 'marketingOrder',
      meta: {
        title: '订单管理'
      }
    }]
  }, {
    path: 'GiftSubsidy',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/index'));
      });
    },
    redirect: '/marketingFunction/basicSetup/index',
    name: 'GiftSubsidy',
    meta: {
      title: '礼金补贴活动'
    },
    children: [{
      path: 'moneySubsidy',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/moneySubsidy/index'));
        });
      },
      name: 'moneySubsidy',
      meta: {
        title: '推广位管理'
      }
    }, {
      path: 'basicSetup',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/basicSetup/index'));
        });
      },
      name: 'basicSetup',
      meta: {
        title: '基础设置'
      }
    }, {
      path: 'marketingEvents',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/marketingEvents/index'));
        });
      },
      name: 'marketingEvents',
      meta: {
        title: '活动管理'
      }
    }, {
      path: 'marketingCommodity',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/marketingCommodity/index'));
        });
      },
      name: 'marketingCommodity',
      meta: {
        title: '商品管理'
      }
    }, {
      path: 'marketingOrder',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/marketingOrder/index'));
        });
      },
      name: 'marketingOrder',
      meta: {
        title: '订单管理'
      }
    }]
  }, {
    path: 'superInviter',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/superInviter/index'));
      });
    },
    redirect: '/marketingFunction/superInviter/index',
    name: 'superInviter',
    meta: {
      title: '超级邀请人'
    },
    children: [{
      path: 'superInviter',
      component: function component() {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/marketingFunction/superInviter/index'));
        });
      },
      name: 'superInviter',
      meta: {
        title: '超级邀请人'
      }
    }]
  }, {
    path: 'superRedRank',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/marketingCampaign/superRedRank'));
      });
    },
    name: 'superRedRank',
    meta: {
      title: '超红排行榜'
    }
  }, {
    path: 'commerce',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/marketingCampaign/commerce'));
      });
    },
    name: 'commerce',
    meta: {
      title: '带货排行榜'
    }
  }]
},
// {
//   path: '/LittleActivityCreation',
//   component: Layout,
//   redirect: '/LittleActivityCreation/index',
//   name: 'LittleActivityCreation',
//   meta: {
//     title: '自定义活动管理',
//     roles: ['app_admin']
//   },
//   children: [

//     {
//       path: 'LittleActivityCreation',
//       component: () => import('@/views/LittleActivityCreation/index'),
//       name: 'LittleActivityCreation',
//       meta: { title: '自定义活动管理', roles: ['app_admin'], keepAlive: true }
//     }

//   ]
// },

{
  path: '/financialManagement',
  component: _layout.default,
  redirect: '/financialManagement/withdrawalManagement/index',
  name: 'financialManagement',
  meta: {
    title: '财务管理',
    roles: ['app_admin']
  },
  children: [{
    path: 'withdrawalManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/financialManagement/withdrawalManagement/index'));
      });
    },
    name: 'withdrawalManagement',
    meta: {
      title: '会员提现管理',
      roles: ['app_admin']
    }
  }, {
    path: 'monthlyBalanceStatement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/financialManagement/monthlyBalanceStatement/index'));
      });
    },
    name: 'monthlyBalanceStatement',
    meta: {
      title: '月结对账单',
      roles: ['app_admin']
    }
  }, {
    path: 'dailySettlementStatement',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/financialManagement/dailySettlementStatement/index'));
      });
    },
    name: 'dailySettlementStatement',
    meta: {
      title: '日结账单'
    }
  }, {
    path: 'withdrawalAudit',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/financialManagement/withdrawalAudit/index'));
      });
    },
    name: 'withdrawalAudit',
    meta: {
      title: '提现账户审核',
      roles: ['app_admin']
    }
  },
  // {
  //   path: 'platformDetail',
  //   component: () => import('@/views/financialManagement/monthlyBalanceStatement/platformDetail'),
  //   name: 'platformDetail',
  //   meta: { title: '平台明细', roles: ['app_admin'] },
  //   hidden: true
  // },
  // {
  //   path: 'memberAccountDetail',
  //   component: () => import('@/views/financialManagement/monthlyBalanceStatement/memberAccountDetail'),
  //   name: 'memberAccountDetail',
  //   meta: { title: '会员出账明细', roles: ['app_admin'] },
  //   hidden: true
  // },
  {
    path: 'withdrawalRulesConfiguration',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/financialManagement/withdrawalRulesConfiguration/index'));
      });
    },
    name: 'withdrawalRulesConfiguration',
    meta: {
      title: '提现规则配置',
      roles: ['app_admin']
    }
  }, {
    path: 'memberBalanceDetails',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/financialManagement/memberBalanceDetails/index'));
      });
    },
    name: 'memberBalanceDetails',
    meta: {
      title: '会员余额明细',
      roles: ['app_admin']
    }
  }, {
    path: 'balanceBatchSend',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/financialManagement/balanceBatchSend/index'));
      });
    },
    name: 'balanceBatchSend',
    meta: {
      title: '余额批量发放',
      roles: ['app_admin']
    }
  }]
}, {
  path: '/shoppingGift',
  component: _layout.default,
  redirect: '/shoppingGift/accountDetails/index',
  name: 'shoppingGift',
  meta: {
    title: '淘礼金',
    roles: ['app_admin']
  },
  children: [{
    path: 'accountDetails',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/shoppingGift/accountDetails/index'));
      });
    },
    name: 'accountDetails',
    meta: {
      title: '淘礼金账户明细',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'createRecord',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/shoppingGift/createRecord/index'));
      });
    },
    name: 'createRecord',
    meta: {
      title: '淘礼金创建记录',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'recordDetails',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/shoppingGift/createRecord/recordDetails'));
      });
    },
    name: 'recordDetails',
    meta: {
      title: '淘礼金详情',
      roles: ['app_admin'],
      keepAlive: true
    },
    hidden: true
  }, {
    path: 'tljPromotionposition',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/shoppingGift/tljPromotionposition/index'));
      });
    },
    name: 'tljPromotionposition',
    meta: {
      title: '淘礼金推广位管理',
      keepAlive: true
    }
  }]
}, {
  path: '/authorityManagement_user_app',
  component: _layout.default,
  redirect: '/personnelManagement_user_app',
  name: 'personnelManagement_user_app',
  meta: {
    title: '权限管理',
    roles: ['app_admin']
  },
  children: [{
    path: 'personnelManagement_user_app',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement_user_app/personnelManagement_user_app'));
      });
    },
    name: 'personnelManagement_user_app',
    meta: {
      title: '人员管理',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'roleAuthority_user_app',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement_user_app/roleAuthority_user_app'));
      });
    },
    name: 'roleAuthority_user_app',
    meta: {
      title: '角色权限',
      roles: ['app_admin'],
      keepAlive: true
    }
  }, {
    path: 'logList',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/authorityManagement_user_app/logList'));
      });
    },
    name: 'logList',
    meta: {
      title: '管理日志'
    }
  }]
}, {
  path: '/dataAdmin',
  component: _layout.default,
  redirect: '/memberData',
  name: 'memberData',
  meta: {
    title: '数据管理',
    roles: ['app_admin']
  },
  children: [{
    path: 'memberData',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/dataAdmin/memberData'));
      });
    },
    name: 'memberData',
    meta: {
      title: '直邀粉丝数据统计',
      roles: ['app_admin']
    }
  }]
}, {
  path: '/appBasicSetup',
  component: _layout.default,
  redirect: '/appBasicSetup/InviteToShare',
  name: 'appBasicSetup',
  meta: {
    title: 'APP基础设置'
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/index'));
      });
    },
    name: 'baseIndex',
    meta: {
      title: '基础信息设置'
    }
  }, {
    path: 'patternConfiguratio',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/patternConfiguratio'));
      });
    },
    name: 'patternConfiguratio',
    meta: {
      title: '模式设置'
    }
  }, {
    path: 'secondaryPageSetup',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/secondaryPageSetup'));
      });
    },
    name: 'secondaryPageSetup',
    meta: {
      title: '二级页面设置'
    }
  }, {
    path: 'threePartyConfiguration',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/threePartyConfiguration'));
      });
    },
    name: 'threePartyConfiguration',
    meta: {
      title: '阿里云oss配置'
    }
  }, {
    path: 'loginPageConfiguration',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/loginPageConfiguration'));
      });
    },
    name: 'loginPageConfiguration',
    meta: {
      title: '登录页配置'
    }
  }, {
    path: 'goodsDetailSet',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/goodsDetailSet'));
      });
    },
    name: 'goodsDetailSet',
    meta: {
      title: '商品详情页'
    }
  }, {
    path: 'paymentSettings',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/paymentSettings'));
      });
    },
    name: 'paymentSettings',
    meta: {
      title: '支付配置'
    }
  }, {
    path: 'labelConfiguration',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appBasicSetup/labelConfiguration'));
      });
    },
    name: 'labelConfiguration',
    meta: {
      title: '商品标签配置'
    }
  }]
}, {
  path: '/hierarchicalCommissionAllocation',
  component: _layout.default,
  redirect: '/hierarchicalCommissionAllocation/upgradeConfiguration/index',
  name: 'hierarchicalCommissionAllocation',
  meta: {
    title: '等级分佣设置'
  },
  children: [{
    path: 'upgradeConfiguration',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/hierarchicalCommissionAllocation/upgradeConfiguration'));
      });
    },
    name: 'upgradeConfiguration',
    meta: {
      title: '升级中心装修'
    }
  }, {
    path: 'RankCommission',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/hierarchicalCommissionAllocation/RankCommission'));
      });
    },
    name: 'RankCommission',
    meta: {
      title: '等级分佣配置'
    }
  }]
}, {
  path: '/appSet',
  component: _layout.default,
  redirect: '/appSet',
  name: 'appSet1',
  meta: {
    title: 'app打包&发版',
    roles: ['app_admin']
  },
  children: [{
    path: 'appSet',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appSet/index'));
      });
    },
    name: 'appSet',
    meta: {
      title: '云编译',
      roles: ['app_admin']
    }
  }, {
    path: 'versionUpdate',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/appSet/versionUpdate'));
      });
    },
    name: 'versionUpdate',
    meta: {
      title: '版本更新',
      roles: ['app_admin']
    }
  }]
}, {
  path: '/wxOfficialAdmin',
  component: _layout.default,
  redirect: '/wxOfficialAdmin',
  name: 'wxOfficialAdmin1',
  meta: {
    title: '公众号配置',
    roles: ['app_admin']
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/wxOfficialAdmin/index'));
      });
    },
    name: 'wxOfficialAdmin',
    meta: {
      title: '公众号配置',
      roles: ['app_admin']
    }
  }
  // {
  //   path: 'versionUpdate',
  //   component: () => import('@/views/appSet/versionUpdate'),
  //   name: 'versionUpdate',
  //   meta: { title: '版本更新', roles: ['app_admin'] }
  // }
  ]
}, {
  path: '/messagePush',
  component: _layout.default,
  redirect: '/messagePush/SMSSettings',
  name: 'messagePush',
  meta: {
    title: '消息推送'
  },
  children: [{
    path: 'SMSSettings',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/messagePush/SMSSettings'));
      });
    },
    name: 'SMSSettings',
    meta: {
      title: '短信基础设置'
    }
  }, {
    path: 'TextMessageRecord',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/messagePush/TextMessageRecord'));
      });
    },
    name: 'TextMessageRecord',
    meta: {
      title: '短信发送记录'
    }
  },
  // {
  //   path: 'PushSettings',
  //   component: () => import('@/views/messagePush/PushSettings'),
  //   name: 'PushSettings',
  //   meta: { title: '推送基础设置' }
  // },
  {
    path: 'PushMessageCreation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/messagePush/PushMessageCreation'));
      });
    },
    name: 'PushMessageCreation',
    meta: {
      title: '推送消息创建'
    }
  }, {
    path: 'PushMessageRecord',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/messagePush/PushMessageRecord'));
      });
    },
    name: 'PushMessageRecord',
    meta: {
      title: '推送消息记录'
    }
  }]
}, {
  path: '/allianceAuthorization',
  component: _layout.default,
  redirect: '/allianceAuthorization/TBAllianceAuthorization',
  name: 'allianceAuthorization',
  meta: {
    title: '联盟授权'
  },
  children: [{
    path: 'AuthorizationCollection',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/AuthorizationCollection'));
      });
    },
    name: 'AuthorizationCollection',
    meta: {
      title: '授权列表'
    }
  }, {
    path: 'AssociationServiceFee',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/AssociationServiceFee'));
      });
    },
    name: 'AssociationServiceFee',
    meta: {
      title: '联盟比例预留'
    }
  }, {
    path: 'TBAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/TBAllianceAuthorization'));
      });
    },
    name: 'TBAllianceAuthorization',
    meta: {
      title: '淘宝联盟'
    }
  }, {
    path: 'JDAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/JDAllianceAuthorization'));
      });
    },
    name: 'JDAllianceAuthorization',
    meta: {
      title: '京东联盟'
    }
  }, {
    path: 'PDDAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/PDDAllianceAuthorization'));
      });
    },
    name: 'PDDAllianceAuthorization',
    meta: {
      title: '多多进宝'
    }
  }, {
    path: 'WPHAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/WPHAllianceAuthorization'));
      });
    },
    name: 'WPHAllianceAuthorization',
    meta: {
      title: '唯品会'
    }
  }, {
    path: 'DYAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/DYAllianceAuthorization'));
      });
    },
    name: 'DYAllianceAuthorization',
    meta: {
      title: '抖音'
    }
  }, {
    path: 'KSAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/KSAllianceAuthorization'));
      });
    },
    name: 'KSAllianceAuthorization',
    meta: {
      title: '快手'
    }
  }, {
    path: 'DDAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/DDAllianceAuthorization'));
      });
    },
    name: 'DDAllianceAuthorization',
    meta: {
      title: '滴滴'
    }
  }, {
    path: 'MTAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/MTAllianceAuthorization'));
      });
    },
    name: 'MTAllianceAuthorization',
    meta: {
      title: '美团'
    }
  }, {
    path: 'ELMAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/ELMAllianceAuthorization'));
      });
    },
    name: 'ELMAllianceAuthorization',
    meta: {
      title: '饿了么'
    }
  }, {
    path: 'TXYXAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/TXYXAllianceAuthorization'));
      });
    },
    name: 'TXYXAllianceAuthorization',
    meta: {
      title: '腾讯云选'
    }
  }, {
    path: 'ZCKQAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/ZCKQAllianceAuthorization'));
      });
    },
    name: 'ZCKQAllianceAuthorization',
    meta: {
      title: '直充卡券'
    }
  }, {
    path: 'ZXDDAllianceAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/ZXDDAllianceAuthorization'));
      });
    },
    name: 'ZXDDAllianceAuthorization',
    meta: {
      title: '在线点单'
    }
  }, {
    path: 'TBAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/TBAuthorization'));
      });
    },
    name: 'TBAuthorization',
    meta: {
      title: '淘宝联盟'
    }
  }, {
    path: 'JDAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/JDAuthorization'));
      });
    },
    name: 'JDAuthorization',
    meta: {
      title: '京东联盟'
    }
  }, {
    path: 'DDJBAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/DDJBAuthorization'));
      });
    },
    name: 'DDJBAuthorization',
    meta: {
      title: '多多进宝'
    }
  }, {
    path: 'WPHAuthorization',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/allianceAuthorization/WPHAuthorization'));
      });
    },
    name: 'WPHAuthorization',
    meta: {
      title: '唯品会'
    }
  }]
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new _vueRouter.default({
    mode: 'history',
    // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
var _default = exports.default = router;